module.exports = __webpack_public_path__ + "img/horse.edd6af3d.png";